export interface MockEInvoice {
    id: string;
    invoiceId: string;
    invoiceNumber: string;
    irn: string;
    ackNumber: string;
    ackDate: string;
    signedInvoiceJson: string;
    qrCodeData: string;
    status: 'GENERATED' | 'CANCELLED' | 'PENDING' | 'FAILED';
    cancelledAt: string | null;
    cancelReason: string | null;
    irpResponse: string;
    generatedBy: string;
    createdAt: string;
}

export let mockEInvoices: MockEInvoice[] = [
    {
        id: 'ei-001',
        invoiceId: 'si-001',
        invoiceNumber: 'INV-2024-001',
        irn: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2',
        ackNumber: '232410123456789',
        ackDate: '2024-04-15T10:30:00Z',
        signedInvoiceJson: '{"SignedInvoice":"eyJhbGciOiJSUzI1NiJ9...","SignedQRCode":"eyJhbGciOiJSUzI1NiJ9..."}',
        qrCodeData: 'https://einvoice1.gst.gov.in/invoice/232410123456789',
        status: 'GENERATED',
        cancelledAt: null,
        cancelReason: null,
        irpResponse: '{"Status":"1","InfoDtls":[{"InfCd":"ENINV-LGN-001"}]}',
        generatedBy: 'Admin User',
        createdAt: '2024-04-15T10:30:00Z',
    },
    {
        id: 'ei-002',
        invoiceId: 'si-002',
        invoiceNumber: 'INV-2024-002',
        irn: 'b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3',
        ackNumber: '232410123456790',
        ackDate: '2024-04-10T09:00:00Z',
        signedInvoiceJson: '{"SignedInvoice":"eyJhbGciOiJSUzI1NiJ9..."}',
        qrCodeData: 'https://einvoice1.gst.gov.in/invoice/232410123456790',
        status: 'CANCELLED',
        cancelledAt: '2024-04-10T15:00:00Z',
        cancelReason: 'Invoice raised for wrong customer',
        irpResponse: '{"Status":"1"}',
        generatedBy: 'Admin User',
        createdAt: '2024-04-10T09:00:00Z',
    },
    {
        id: 'ei-003',
        invoiceId: 'si-004',
        invoiceNumber: 'INV-2024-004',
        irn: '',
        ackNumber: '',
        ackDate: '',
        signedInvoiceJson: '',
        qrCodeData: '',
        status: 'FAILED',
        cancelledAt: null,
        cancelReason: null,
        irpResponse: '{"Status":"0","ErrorDetails":[{"ErrorCode":"2150","ErrorMessage":"Duplicate IRN"}]}',
        generatedBy: 'Admin User',
        createdAt: '2024-04-18T14:00:00Z',
    },
];